import { Menu, MenuDivider, MenuItem, Position } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import CustomPopover from "components/Atoms/CustomPopover"
import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { OPEN_BULK_UPDATE_DIALOG } from "store/order.redux"
import AddTransanction from "../actions/AddTransanction"

const OrderActions = ({ order, onlyTransaction = false }) => {
  const [params, setParams] = useSearchParams()
  const [isOpen, setOpen] = useState(false)
  const dispatch = useDispatch()
  return (
    <>
      <CustomPopover
        position={Position.BOTTOM_LEFT}
        minimal={true}
        content={
          <Menu>
            {!onlyTransaction && (
              <>
                <MenuDivider title="Order Display" />
                <MenuItem
                  icon="th-list"
                  text="Order Details"
                  onClick={() => {
                    params.set("id", order?.id)
                    setParams(params)
                  }}
                />
                <MenuDivider title="Order Operation" />
                <MenuItem
                  onClick={e => {
                    dispatch({
                      type: OPEN_BULK_UPDATE_DIALOG,
                      payload: order,
                    })
                  }}
                  icon="edit"
                  text="Update Order"
                />
              </>
            )}
            <MenuItem
              icon="bank-account"
              text="Add transaction"
              onClick={e => {
                setOpen(true)
              }}
            />
          </Menu>
        }
      >
        <CustomButton icon="more" minimal={true} />
      </CustomPopover>
      <AddTransanction
        isOpen={isOpen}
        onClose={e => setOpen(false)}
        order={order}
      />
    </>
  )
}

export default OrderActions
